import { render, staticRenderFns } from "./modelBodyOptions.vue?vue&type=template&id=073c18cc&scoped=true&"
import script from "./modelBodyOptions.vue?vue&type=script&lang=js&"
export * from "./modelBodyOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073c18cc",
  null
  
)

export default component.exports